import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  buttonsContainer: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px', paddingBottom: '16px' },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
  },
  accessText: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    color: colors.secondaryText,
    gap: '4px',
  },
  selectAllLabel: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: colors.secondaryText,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
  },
  organizersHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: anatomy['space-20'],
  },
  qrButtonsPanel: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px' },
  menuItem: {
    color: colors.primaryText,
    fontSize: '14px',
  },
  segment: {
    padding: '10px 0 ',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '20px',
  },
  label: {
    paddingRight: '10px',
  },
});
